import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { verifyAdminPass } from "@/lib/api";
import { secureSet } from "@/lib/secureStorage";
import { errorMessage } from "@/lib/errorMessage";

export default function Unlock({ passKey, onUnlocked }) {
  const [val, setVal] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await verifyAdminPass(val);
      secureSet(passKey, val);
      onUnlocked(val);
    } catch (err) {
      toast.error(errorMessage(err, "Wrong passphrase."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F6] flex items-center justify-center px-6">
      <form
        onSubmit={submit}
        className="max-w-sm w-full bg-white border border-[#E5E2DC] rounded-2xl p-8 space-y-5"
      >
        <div className="flex items-center gap-2 text-[#2B5339]">
          <ShieldCheck size={18} />
          <span className="text-sm font-medium">Admin access</span>
        </div>
        <div>
          <h1 className="text-2xl font-medium text-[#1C2B23]">Back office</h1>
          <p className="text-sm text-[#5C6B62] mt-1">
            Enter the admin passphrase to view usage, revenue, and listings.
          </p>
        </div>
        <input
          data-testid="admin-pass-input"
          type="password"
          value={val}
          onChange={(e) => setVal(e.target.value)}
          placeholder="passphrase"
          autoFocus
          className="w-full bg-[#F9F8F6] border border-[#E5E2DC] rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#2B5339]"
        />
        <button
          data-testid="admin-unlock-btn"
          type="submit"
          disabled={loading || !val}
          className="w-full bg-[#1C2B23] text-white rounded-lg py-2.5 text-sm font-medium hover:bg-[#2B5339] transition-colors disabled:opacity-50 inline-flex items-center justify-center gap-2"
        >
          {loading && <Loader2 size={14} className="animate-spin" />}
          Unlock
        </button>
        <Link to="/" className="block text-center text-xs text-[#5C6B62] hover:text-[#2B5339]">
          ← Back to calculator
        </Link>
      </form>
    </div>
  );
}
